import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function DetailsNotes({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Notes")}</legend>
      <input
        name="detailsNotes"
        onChange={onChange}
        value={searchObject.detailsNotes || ""}
        className="form-control fontsize-legend"
        type="text"
      />
    </div>
  );
}
